<template>
    <div>
        <static-loading-indicator-icon :with-card="true"/>

        <div class="card shadow-sm" v-if="!$store.getters.isExecutingRequest">
            <div class="card-body">
                <h5 class="card-title">
                    {{ $t('pages.subscription.cancel_subscription') }}
                </h5>

                <p v-html="$t('pages.subscription.cancel.are_you_sure', {date: $date(willBeRenewedAt).format('DD.MM.YYYY')})"></p>

                <div class="mt-5">
                    <a @click="cancelSubscription" class="text-danger cursor-pointer">
                        {{ $t('pages.subscription.cancel.yes_cancel') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StaticLoadingIndicatorIcon from "../../../../Includes/StaticLoadingIndicatorIcon";
import PageHeader from "../../../../Includes/PageHeader";
import SubscriptionRepository from "../../../../../repositories/Subscription/SubscriptionRepository";
import AuthRepository from "../../../../../repositories/Auth/AuthRepository";
export default {
    name: "CancelSubscription",
    components: {PageHeader, StaticLoadingIndicatorIcon},
    data: () => ({
        isSubscribed: false,
        willBeRenewedAt: null,
    }),
    mounted() {
        this.getSubscriptionStatus();
    },
    methods: {
        cancelSubscription() {
            SubscriptionRepository
                .cancelSubscription()
                .then((res) => {
                    AuthRepository
                        .fetchAuthDetails()
                        .then(() => {
                            this.$snotify.html(this.$t('pages.subscription.cancel.successfully_canceled', {date: this.$date(this.willBeRenewedAt).format('DD.MM.YYYY')}));
                            this.$router.push({name: 'cancel-subscription-done', query: {expiryDate: this.willBeRenewedAt }});
                        })
                })
        },
        getSubscriptionStatus() {
            SubscriptionRepository
                .getStatus()
                .then((res) => {
                    this.isSubscribed = res.data.active;
                    this.willBeRenewedAt = res.data.will_be_renewed_at;
                });
        }
    }
}
</script>

<style scoped>

</style>
